/**
 * Ana sayfa CMS içeriğini çekip i18n `home` namespace'ine birleştirir (LeadForm dahil).
 * @param {{ enabled?: boolean }} [options] — `enabled: false` iken istek atılmaz (Lighthouse: gereksiz ağ zinciri).
 */

import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { ENV } from '../../config/env'

export function useHomeCmsSync(options = {}) {
  const enabled = options.enabled !== false
  const { i18n } = useTranslation()

  useEffect(() => {
    if (!enabled) return
    const lang = (i18n.language || 'tr').split('-')[0]
    const base = ENV.API_BASE_URL.replace(/\/+$/, '')
    if (!base) return

    let cancelled = false

    ;(async () => {
      try {
        const r = await fetch(`${base}/public/home-content.php?lang=${encodeURIComponent(lang)}`)
        const body = await r.json()
        if (cancelled) return
        const c = body?.success ? body?.data?.content : null
        if (c && typeof c === 'object' && !Array.isArray(c) && Object.keys(c).length > 0) {
          i18n.addResourceBundle(lang, 'home', c, true, true)
        }
      } catch {
        /* sessiz: CMS yok veya ağ hatası — yerel JSON kullanılır */
      }
    })()

    return () => {
      cancelled = true
    }
  }, [i18n, i18n.language, enabled])
}
